import { FormControl, IconButton, useMediaQuery } from '@chakra-ui/react';
import { Form, Formik, FormikHelpers } from 'formik';
import { Field } from '@/components/Fields';
import { ChangeEvent } from 'react';
import * as Yup from 'yup';
import { CloseIcon } from '@chakra-ui/icons';

const SearchSchema = Yup.object().shape({
  searchQuery: Yup.string().trim(),
});

interface SearchFormProps {
  isLoading: boolean;
  onSearch: (query: string) => void;
}

export const SearchForm = ({ isLoading, onSearch }: SearchFormProps) => {
  const [isDesktop] = useMediaQuery('(min-width: 768px)');
  const handleClear = (setFieldValue: FormikHelpers<{ searchQuery: string }>['setFieldValue']) => {
    setFieldValue('searchQuery', '');
    onSearch('');
  };
  return (
    <Formik initialValues={{ searchQuery: '' }} validationSchema={SearchSchema} onSubmit={() => {}}>
      {({ values, handleChange, setFieldValue }) => (
        <Form style={{ width: '100%' }}>
          <FormControl>
            <Field
              type="text"
              name="searchQuery"
              onDark
              placeholder="Search by email"
              autoComplete="off"
              h="40px"
              w={{ base: '100%', md: '300px' }}
              mb={0}
              placeholderFontSize="16px"
              fontSize="16px"
              readOnly={isLoading}
              value={values.searchQuery}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                handleChange(e);
                onSearch(e.target.value);
              }}
              style={{
                pointerEvents: isLoading ? 'none' : 'auto',
                opacity: isLoading ? 0.7 : 1,
              }}
              rightElement={
                values.searchQuery ? (
                  <IconButton
                    aria-label="Clear search"
                    icon={<CloseIcon />}
                    size="sm"
                    variant="ghost"
                    isDisabled={isLoading}
                    onClick={() => handleClear(setFieldValue)}
                    _hover={{ bg: 'transparent' }}
                    color="white"
                  />
                ) : undefined
              }
              rightElementStyles={{
                mr: '8px',
              }}
              groupStyles={{
                width: isDesktop ? 'fit-content' : '100%',
              }}
            />
          </FormControl>
        </Form>
      )}
    </Formik>
  );
};
